import {ErrorBoundary} from '@github-ui/react-core/error-boundary'
import {lazy, Suspense} from 'react'

import {useEnvironmentSetupLoader} from './use-environment-setup-loader'

const EnvironmentSetup = lazy(() => import('./EnvironmentSetup'))

export function EnvironmentSetupLazy({visualOnly = false}: {visualOnly?: boolean}) {
  const {cubeEnabled} = useEnvironmentSetupLoader()

  if (visualOnly && !cubeEnabled) return null

  return (
    <ErrorBoundary boundaryName="environment-setup" fallback={null}>
      <Suspense fallback={null}>
        <EnvironmentSetup visualOnly={visualOnly} />
      </Suspense>
    </ErrorBoundary>
  )
}
